import Vue from 'vue'
import Router from 'vue-router'
Vue.use(Router)

export default new Router({
  base: '/',
  routes: [{
      path: '/',
      name: 'demo',
      component: (resolve) => require(['../views/demo'], resolve),
    }
    //课单
    , {
      path: '/discovery/courseSummary',
      name: 'courseSummary',
      component: (resolve) => require(['../views/discovery/courseSummary'], resolve),
      meta: {
        title: '课单'
      }
    }
    //全部课程
    , {
      path: '/discovery/allCourse/:labelId',
      name: 'allCourse',
      component: (resolve) => require(['../views/discovery/allCourse'], resolve),
      meta: {
        title: '全部课程'
      }
    }
    //课程列表-运营活动
    , {
      path: '/discovery/allCourseActivity/:labelId',
      name: 'allCourseActivity',
      component: (resolve) => require(['../views/discovery/allCourseActivity'], resolve),
      meta: {
        title: '课程推荐'
      }
    }
    //课程排行榜
    , {
      path: '/discovery/rankingList/:showTit?',
      name: 'rankingList',
      component: (resolve) => require(['../views/discovery/rankingList'], resolve),
      meta: {
        title: '课程排行榜'
      }
    }
    //vip课程主页 
    , {
      path: '/vip/vip',
      name: 'vip',
      component: (resolve) => require(['../views/vip/vip'], resolve),
      meta: {
        title: '知到VIP'
      }
    }
    //vip上新速递更多 
    , {
      path: '/vip/vipNewExpress',
      name: 'vipNewExpress',
      component: (resolve) => require(['../views/vip/vipNewExpress'], resolve),
      meta: {
        title: 'VIP上新速递'
      }
    }
    //vip好课榜 
    , {
      path: '/vip/vipRankingList',
      name: 'vipRankingList',
      component: (resolve) => require(['../views/vip/vipRankingList'], resolve),
      meta: {
        title: 'VIP好课榜'
      }
    }
    //vip课程魔方 
    , {
      path: '/vip/vipMagicCourse/:labelId',
      name: 'vipMagicCourse',
      component: (resolve) => require(['../views/vip/vipMagicCourse'], resolve),
      meta: {
        title: 'VIP课程魔方'
      }
    }
    //vip精品课程
    , {
      path: '/vip/vipBestCourse',
      name: 'vipBestCourse',
      component: (resolve) => require(['../views/vip/vipBestCourse'], resolve),
      meta: {
        title: 'VIP精品课程'
      }
    }
    //vip学校课程
    , {
      path: '/vip/vipSchoolCourse/:schoolId',
      name: 'vipSchoolCourse',
      component: (resolve) => require(['../views/vip/vipSchoolCourse'], resolve),
      meta: {
        title: 'VIP名校好课'
      }
    }
    //vip名师专栏
    , {
      path: '/vip/vipTeacherColumn',
      name: 'vipTeacherColumn',
      component: (resolve) => require(['../views/vip/vipTeacherColumn'], resolve),
      meta: {
        title: 'VIP名师专栏'
      }
    }
    //vip专属电子书
    , {
      path: '/vip/vipEbook',
      name: 'vipEbook',
      component: (resolve) => require(['../views/vip/vipEbook'], resolve),
      meta: {
        title: 'VIP名师专栏'
      }
    }
     //vip开通会员
     , {
      path: '/vip/vipOpen',
      name: 'vipOpen',
      component: (resolve) => require(['../views/vip/vipOpen'], resolve),
      meta: {
        title: 'VIP会员'
      }
    },
     //vip开通会员
     , {
      path: '/vipnew/vipOpen',
      name: 'vipOpen',
      component: (resolve) => require(['../views/vip/vipOpen'], resolve),
      meta: {
        title: 'VIP会员'
      }
    },
    //vip开通体验
    , {
      path: '/vip/vipExperience',
      name: 'vipExperience',
      component: (resolve) => require(['../views/vip/vipExperience'], resolve),
      meta: {
        title: 'VIP体验卡'
      }
    }
    , {
      path: '/vip/vipExperience1',
      name: 'vipExperience1',
      component: (resolve) => require(['../views/vip/vipExperience1'], resolve),
      meta: {
        title: 'VIP体验卡'
      }
    }
         //vip会员日
         , {
          path: '/vip/vipDate',
          name: 'vipDate',
          component: (resolve) => require(['../views/vip/vipDate'], resolve),
          meta: {
            title: 'vip会员日'
          }
        }
    //充值页面
    , {
      path: '/recharge/recharge',
      name: 'recharge',
      component: (resolve) => require(['../views/recharge/recharge'], resolve),
      meta: {
        title: '我的账户'
      }
    }
    //treenity充值页面
    , {
      path: '/recharge/rechargeForTN',
      name: 'rechargeForTN',
      component: (resolve) => require(['../views/recharge/RechargeForTN'], resolve),
      meta: {
        title: '我的账户'
      }
    }
    //购买记录
    , {
      path: '/recharge/rechargelist',
      name: 'rechargelist',
      component: (resolve) => require(['../views/recharge/rechargelist'], resolve),
      meta: {
        title: '购买记录'
      }
    }
    //结算台
    , {
      path: '/recharge/setTable/:goodsID/:businessType',
      name: 'setTable',
      component: (resolve) => require(['../views/recharge/setTable'], resolve),
      meta: {
        title: '结算台'
      }
    }
    //千人千面
    , {
      path: '/discovery/RecommendContent/:interestLabelId/:labelId/:interestLabelName',
      name: 'RecommendContent',
      component: (resolve) => require(['../views/discovery/RecommendContent'], resolve),
      meta: {
        title: '千人千面'
      }
    }, {
      path: '/microMajor/microMajorList',
      name: 'microMajorList',
      component: (resolve) => require(['../views/microMajor/microMajorList'], resolve),
      meta: {
        title: '微专业'
      }
    }
    //名师分享
    , {
      path: '/discovery/teacherSharing',
      name: 'teacherSharing',
      component: (resolve) => require(['../views/discovery/teacherSharing'], resolve),
      meta: {
        title: '名师分享'
      }
    }, {
      path: '/discovery/excellentCourse',
      name: 'excellentCourse',
      component: (resolve) => require(['../views/discovery/excellentCourse'], resolve),
      meta: {
        title: '国家精品课程'
      }
    }, {
      path: '/discovery/videoGraphics/:sectionId',
      name: 'videoGraphics',
      component: (resolve) => require(['../views/discovery/videoGraphics'], resolve),
      meta: {
        title: '视频图文'
      }
    }, {
      path: '/courseVR/knowledgePoint/:courseId',
      name: 'knowledgePoint',
      component: (resolve) => require(['../views/courseVR/knowledgePoint'], resolve),
      meta: {
        title: 'VR课程'
      }
    }, {
      path: '/courseVR/knowledgeTest/:courseId',
      name: 'knowledgeTest',
      component: (resolve) => require(['../views/courseVR/knowledgeTest2'], resolve),
      meta: {
        title: '知识点测验'
      }
    }, {
      path: '/discovery/brainstorming',
      name: 'brainstorming',
      component: (resolve) => require(['../views/discovery/brainstorming'], resolve),
      meta: {
        title: '头脑风暴'
      }
    }, {
      path: '/teacherSaid/interestTag',
      name: 'interestTag',
      component: (resolve) => require(['../views/teacherSaid/interestTag'], resolve),
      meta: {
        title: '兴趣标签'
      }
    }, {
      path: '/teacherSaid/managerData',
      name: 'managerData',
      component: (resolve) => require(['../views/teacherSaid/managerData'], resolve),
      meta: {
        title: '管理者数据'
      }
    },
    {
      path: '/courseVR/blank',
      name: 'blank',
      component: (resolve) => require(['../views/courseVR/blank'], resolve),
      meta: {
        title: '知识点测验'
      }
    }, {
      path: '/problemCollect/problemFeedback',
      name: 'problemFeedback',
      component: (resolve) => require(['../views/problemCollect/problemFeedback'], resolve),
      meta: {
        title: '问题搜集'
      }
    }, {
      path: '/problemCollect/submitSuccess',
      name: 'submitSuccess',
      component: (resolve) => require(['../views/problemCollect/submitSuccess'], resolve),
      meta: {
        title: '问题提交成功'
      }
    },{
      path: '/courseScheduling/course',
      name: 'courseSchedule',
      component: (resolve) => require(['../views/courseScheduling/course'], resolve),
      meta: {
        title: '智慧树-见面课排课'
      }
    },{
      path: '/courseScheduling/rules',
      name: 'rules',
      component: (resolve) => require(['../views/courseScheduling/rules'], resolve),
      meta: {
        title: '智慧树-见面课排课规则'
      }
    },
    {
      path: '/courseScheduling/success',
      name: 'success',
      component: (resolve) => require(['../views/courseScheduling/success'], resolve),
      meta: {
        title: '智慧树-见面课排课'
      }
    },
  ]
});




// WEBPACK FOOTER //
// ./src/router/index.js